import { Button, Card, Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import InputText from "../../Components/Input";
import Label from "../../Components/label";
import {
  deleteDealerFosMapping,
  getAllStateList,
  getDealerList,
  getEmployeeList,
  getEmployeeSuggestion,
  saveUpdateDealerFosMappingMaster,
} from "../../Redux/Services/delaerMapping";

const DealerMapping = () => {
  const [form] = Form.useForm();
  const [dealer, setDealer] = useState([]);
  const [state, setState] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [branch, setBranch] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [submittable, setSubmittable] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [employeeListDiff, setEmployeeListDiff] = useState([]);
  // const filteredOptions = OPTIONS.filter((o) => !selectedItems.includes(o));
  const formValues = Form.useWatch([], form);

  useEffect(() => {
    fetchStateList();
  }, []);

  React.useEffect(() => {
    form
      ?.validateFields({
        validateOnly: true,
      })
      ?.then((res) => {
        setSubmittable(true);
      })
      ?.catch((error) => {
        error?.errorFields?.length > 0 && setSubmittable(false);
      });
  }, [formValues]);

  const fetchStateList = async () => {
    const res = await getAllStateList();
    // if(!res?.errror){
    const array = res?.data?.map((re) => {
      return { label: re?.stateName, value: re?.stateName };
    });
    setState(array);
    // }
  };

  const fetchDealerList = async (state) => {
    console.log(state, "state");
    const res = await getDealerList({ stateName: state });
    if (!res?.errror) {
      const array = res?.data?.map((re) => {
        return { label: re?.dealerName, value: JSON.stringify(re) };
      });
      setDealer(array);
      //   console.log(res, "response");
    }
  };

  const fetchEmplyeeList = async (dealer) => {
    const res = await getEmployeeList({
      dealerName: dealer?.dealerName,
      branch: dealer?.branchCode?.split(","),
    });
    //   if (!res?.errror) {
    //   const array = res?.data?.map((re) => {
    //       return { label: re?.employeeIdName, value: JSON.stringify(re) };
    //     });
    // setEmployeeList(array);
    let result = await res?.data?.map((a) => a?.employeeIdName);
    result && form.setFieldValue("employeeList", result);
    setEmployeeListDiff(result);
    //   }
  };

  const fetchSuggestion = async (dealer) => {
    const response = await getEmployeeSuggestion({
      branch: dealer?.branchCode?.split(","),
      stateName: form.getFieldValue("state"),
    });

    if (!response?.errror) {
      const array = response?.data?.map((re) => {
        return { label: re?.employeeIdName, value: re?.employeeIdName };
      });
      setEmployeeList(array);
    } else {
      setEmployeeList([]);
    }
  };

  const handleFormChange = async (changedFields, allFields) => {
    if (changedFields?.state) {
      fetchDealerList(changedFields?.state);
      form.resetFields(["employeeList", "branch", "dealer"]);
    }
    if (changedFields?.dealer) {
      form.resetFields(["employeeList", "branch"]);
      fetchEmplyeeList(JSON.parse(changedFields?.dealer));
      fetchSuggestion(JSON.parse(changedFields?.dealer));
      const result = await JSON.parse(changedFields?.dealer)?.branchCode;
      const endResult = await result?.split(",");
      form.setFieldValue("branch", endResult);
      setBranchList(endResult);

      //   endResult && setBranch(endResult)
      // console.log(changedFields?.dealer , "dealer");
    }
  };

  const onFinish = async (values) => {
    const employeeId = values?.employeeList.map((re) => {
      return re?.split("|")?.[0];
    });
    const employeeName = values?.employeeList.map((re) => {
      return re?.split("|")?.[1];
    });
    const res = await saveUpdateDealerFosMappingMaster({
      state: values?.state,
      employeeId: employeeId,
      employeeName: employeeName,
      dealerName: JSON.parse(values?.dealer)?.dealerName,
      city: JSON.parse(values?.dealer)?.branchCode?.split(","), //branch
    });

    if (!res.errror) {
      form.resetFields();
      // setState([]);
      setDealer([]);
      setEmployeeList([]);
      setEmployeeListDiff([]);
    }
  };

  const handleKeyPress = (e) => {
    // console.log("keypress",e)
    // if (e.keyCode == 8 || e?.key =="Backspace" || e?.code == "Backspace") {
    //   e.preventDefault();
    // }
  };

  useEffect(() => {
    const res =
      employeeList?.length > 0
        ? employeeList?.filter((o) => !selectedItems.includes(o))
        : [];
    const finalRes = res?.map((item) => ({
      value: item,
      label: item,
    }));

    // console.log(finalRes ,"final")
  }, [employeeList]);

  const handleEmployeeChange = async (value) => {
    // console.log(value, "value");
    // console.log(employeeListDiff, "array1");
    // console.log(value, "array2");
    // //  const res = employeeList.diff(value);
    // const res = employeeListDiff.filter((x) => !value.includes(x));
    // console.log(res, "diff");
    // if(res?.length > 0){
    //   const response = await deleteDealerFosMapping({
    //     employeeId: res?.[0]?.split("-")?.[0],
    //     dealerName: JSON.parse(form.getFieldValue("dealer"))?.dealerName,
    //     city: JSON.parse(form.getFieldValue("dealer"))?.branchCode,
    //   });
    //    if (!response?.error) {
    //      setEmployeeListDiff(value);
    //    }
    // }
  };
  const handleDeselect = async (e) => {
    console.log(e);
    const response = await deleteDealerFosMapping({
      employeeId: e?.split("-")?.[0],
      dealerName: JSON.parse(form.getFieldValue("dealer"))?.dealerName,
      city: JSON.parse(form.getFieldValue("dealer"))?.branchCode,
    });
  };
  return (
    <div>
      {" "}
      <Form
        initialValues={{
          remember: true,
        }}
        name="dynamic_form_nest_item"
        onFinish={onFinish}
        autoComplete="off"
        form={form}
        onValuesChange={handleFormChange}
      >
        <Card
          title=""
          bordered={true}
          style={{ margin: "3%", boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px" }}
        >
          <Row gutter={[32, 0]}>
            <Col lg={12}>
              <Label label="Select State" value={""} />
              <Form.Item
                name={"state"}
                style={{ maxWidth: "320px" }}
                rules={[
                  {
                    required: true,
                    message: `State is mandatory`,
                  },
                  //   {
                  //     pattern: onlyNumericRegex,
                  //     message: "Invalid Applicant ID",
                  //   },
                ]}
              >
                <InputText
                  showSearch
                  type="dropdown"
                  label="Select State"
                  options={state}
                />
              </Form.Item>
            </Col>{" "}
            <Col lg={12}>
              <Label label="Select Dealer" value={""} />
              <Form.Item
                style={{ maxWidth: "320px" }}
                name={"dealer"}
                rules={[
                  {
                    required: true,
                    message: `Dealer is mandatory`,
                  },
                ]}
              >
                <InputText
                  type="dropdown"
                  label="Select Dealer"
                  options={dealer}
                  showSearch
                />
              </Form.Item>
            </Col>{" "}
            <Col lg={12}>
              <Label label="Branch" value={""} />
              <Form.Item
                style={{ maxWidth: "320px" }}
                name={"branch"}
                rules={[
                  {
                    required: true,
                    message: `Branch is mandatory`,
                  },
                ]}
              >
                <InputText
                  disabled={true}
                  type="dropdown"
                  label="Select Branch"
                  mode="multiple"
                  options={branch}
                />
              </Form.Item>
            </Col>{" "}
            <Col lg={12}>
              <Label label="Select Employee " value={""} />
              <Form.Item
                style={{ maxWidth: "320px" }}
                name={"employeeList"}
                rules={[
                  {
                    required: true,
                    message: `Employee Id is mandatory`,
                  },
                ]}
              >
                <InputText
                  showSearch
                  type="dropdown"
                  label="Select Employee"
                  // options={employeeList}
                  // value={selectedItems}
                  onChange={handleEmployeeChange}
                  options={
                    employeeList
                    // .filter((o) => !selectedItems.includes(o))
                    // .map((item) => ({
                    //   value: item,
                    //   label: item,
                    // }))
                  }
                  mode="multiple"
                  onKeyDown={handleKeyPress}
                  onDeselect={handleDeselect}
                />
              </Form.Item>
            </Col>
          </Row>
          <br />

          <Row justify="center" align="middle">
            <Button
              htmlType="submit"
              className="reset-button"
              // disabled={caseFreeze || userFreeze}
              disabled={!submittable}
            >
              Submit
            </Button>
          </Row>

          {/* <Row>
            <p style={{ color: "red" }}>
              <b>{freezeMsg}</b>
            </p>
          </Row> */}
        </Card>
      </Form>
    </div>
  );
};

export default DealerMapping;
